var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.57 132.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.57,0l-15,87.84a3.81,3.81,0,0,1-4.45,3,4,4,0,0,1-1.43-.59L54.79,75.13l-4.7,6.31h0L43.87,89.8a3.79,3.79,0,0,1-6.82-2.65h0l1.81-22.88a3.78,3.78,0,0,1,1-2.21h0l3.63-3.83L76,24,33.35,58.77a3.8,3.8,0,0,1-4.53,0l-7.15-4.34L7.59,45.91a3.8,3.8,0,0,1,.55-6.77h0ZM27.5,72.26a3.66,3.66,0,0,1,5.19,5.16L15.29,96.19A3.66,3.66,0,0,1,10.1,91ZM31.42,93a3.66,3.66,0,1,1,5.41,4.93L6.37,131.79A3.66,3.66,0,0,1,1,126.86Zm27.79-7.94a3.66,3.66,0,0,1,5.59,4.73L39.35,120.17a3.66,3.66,0,1,1-5.59-4.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50.49 80.91 54.79 75.13 45.72 69.81 40.42 66.71 50.49 80.91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.0116725bb2a940f56f0465048d5a3ac4.svg";
export { ForwardRef as ReactComponent };